module.exports = "https://static.energy5.com/_next/static/images/compatible-3fc8eea70a47b3118130f611e45139c6.png";